/* Discount Combine Parts — core storefront script (search, finder, cart drawer, UI). No dependencies. */
(function () {
  'use strict';
  var D = document, W = window;
  var ROOT = (W.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var CFG = W.XCFG || {};
  var TEL = '+61430609882', TELTXT = '0430 609 882', WA = 'https://wa.me/61430609882';
  var GST = CFG.gst || '+ GST';
  var MAKE_COLL = { 'John Deere': 'john-deere', 'Case IH': 'case-ih', 'New Holland': 'new-holland', 'MacDon': 'macdon-parts' };
  var MAKE_ORDER = ['John Deere', 'Case IH', 'New Holland', 'MacDon', 'Massey Ferguson', 'AGCO', 'Claas', 'Kubota', 'Cummins', 'Perkins'];

  function $(s, c) { return (c || D).querySelector(s); }
  function $$(s, c) { return [].slice.call((c || D).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(c) { var n = Number(c) / 100; return isNaN(n) ? '' : '$' + n.toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function norm(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, ''); }
  function store(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }
  function sized(u, w) { if (!u) return ''; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function natural(a, b) { return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' }); }

  /* ---------- Product index (powers search + Find My Part) ---------- */
  var idxPromise = null;
  function loadIndex() {
    if (idxPromise) return idxPromise;
    var cached = store('xIdx4');
    if (cached) {
      try { var o = JSON.parse(cached); if (o && o.t > Date.now() - 3600000 && o.d && o.d.length) return (idxPromise = Promise.resolve(o.d)); } catch (e) {}
    }
    function page(n) {
      return fetch(ROOT + 'collections/all?view=dcp-fitment-index&page=' + n, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('index ' + r.status); return r.json(); });
    }
    idxPromise = page(1).then(function (first) {
      var reqs = [];
      for (var i = 2; i <= first.pages; i++) reqs.push(page(i));
      return Promise.all(reqs).then(function (rest) {
        var all = first.products || [];
        rest.forEach(function (r) { all = all.concat(r.products || []); });
        all.forEach(function (p) {
          p.mk = p.mk || []; p.md = p.md || [];
          p.h = norm([p.t, p.s, p.mk.join(' '), p.md.join(' '), p.ty].join(' '));
        });
        store('xIdx4', JSON.stringify({ t: Date.now(), d: all }));
        return all;
      });
    }).catch(function (e) { idxPromise = null; throw e; });
    return idxPromise;
  }

  /* Matches part numbers ignoring spaces, dashes and case: "213405" finds H213405, "2388 chain" finds 2388 chains. */
  function match(idx, q, limit) {
    var toks = q.split(/\s+/).map(norm).filter(Boolean);
    if (!toks.length) return [];
    var qn = norm(q), out = [];
    idx.forEach(function (p) {
      for (var i = 0; i < toks.length; i++) if (p.h.indexOf(toks[i]) < 0) return;
      var sc = 0, tn = norm(p.t);
      if (norm(p.s) === qn) sc += 200;
      else if (tn.indexOf(qn) > -1) sc += 80;
      if (p.a) sc += 20;
      sc -= p.t.length / 100;
      out.push([sc, p]);
    });
    out.sort(function (a, b) { return b[0] - a[0]; });
    return out.slice(0, limit || 8).map(function (x) { return x[1]; });
  }

  function highlight(text, q) {
    var safe = esc(text);
    var words = q.trim().split(/\s+/).filter(function (w) { return w.length > 1; })
      .map(function (w) { return w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); });
    if (!words.length) return safe;
    return safe.replace(new RegExp('(' + words.join('|') + ')', 'gi'), '<mark>$1</mark>');
  }

  function rowHTML(p, q) {
    var img = p.i ? '<img src="' + esc(p.i) + '" alt="" loading="lazy" width="64" height="64">' : '';
    return '<a class="x-row" href="' + esc(p.u) + '">' +
      '<span class="x-row__img">' + img + '</span>' +
      '<span class="x-row__body"><span class="x-row__t">' + (q ? highlight(p.t, q) : esc(p.t)) + '</span>' +
      '<span class="x-row__m"><b>' + money(p.p) + '</b> <small>' + GST + '</small>' +
      (p.a ? '<span class="x-ok">In stock</span>' : '<span class="x-mut">Call for availability</span>') +
      '</span></span></a>';
  }

  function helpHTML(q) {
    var subj = encodeURIComponent('Part request: ' + q);
    return '<div class="x-help">' +
      '<p><strong>We haven’t found “' + esc(q) + '” online yet.</strong> That doesn’t mean we can’t get it.</p>' +
      '<div class="x-help__btns">' +
      '<a class="x-btn x-btn--pk x-btn--sm" href="tel:' + TEL + '">Call ' + TELTXT + '</a>' +
      '<a class="x-btn x-btn--wa x-btn--sm" href="' + WA + '?text=' + encodeURIComponent('Hi, I need part ' + q + '. My machine is: ') + '" target="_blank" rel="noopener">WhatsApp a photo</a>' +
      '<a class="x-btn x-btn--line x-btn--sm" href="' + ROOT + '#request" data-q="' + esc(q) + '">Request this part</a>' +
      '</div><p class="x-help__mail"><a href="mailto:' + (CFG.email || 'evan@discountcombineparts.com.au') + '?subject=' + subj + '">or email the part number</a></p></div>';
  }

  /* ---------- Live search ---------- */
  function predictive(q) {
    var url = ROOT + 'search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last' +
      '&resources[options][fields]=title,variants.sku,variants.barcode,product_type,tag';
    return fetch(url).then(function (r) { return r.json(); }).then(function (d) {
      var ps = (d && d.resources && d.resources.results && d.resources.results.products) || [];
      return ps.map(function (p) {
        return { t: p.title, u: p.url, i: sized((p.featured_image && p.featured_image.url) || p.image, 120), p: Math.round(Number(p.price) * 100), a: p.available };
      });
    });
  }

  function attachSearch(input) {
    if (input.dataset.xBound) return;
    input.dataset.xBound = '1';
    var host = input.closest('[data-x-search-host]') || input.parentElement;
    var panel = D.createElement('div');
    panel.className = 'x-ls';
    panel.setAttribute('role', 'listbox');
    host.appendChild(panel);
    var timer, active = -1, seq = 0;

    function close() { panel.classList.remove('is-open'); active = -1; }
    function open() { panel.classList.add('is-open'); }
    function render(q, list, total) {
      if (!list.length) { panel.innerHTML = helpHTML(q); open(); return; }
      var more = total > list.length
        ? '<a class="x-ls__all" href="' + ROOT + 'search?type=product&q=' + encodeURIComponent(q) + '">See all ' + total + ' matches →</a>' : '';
      panel.innerHTML = '<div class="x-ls__list">' + list.map(function (p) { return rowHTML(p, q); }).join('') + '</div>' + more;
      open();
    }
    function run() {
      var q = input.value.trim(), my = ++seq;
      if (q.length < 2) { close(); return; }
      if (!panel.innerHTML) { panel.innerHTML = '<div class="x-ls__wait">Searching…</div>'; open(); }
      loadIndex().then(function (idx) {
        if (my !== seq) return;
        var all = match(idx, q, 200);
        render(q, all.slice(0, 8), all.length);
      }).catch(function () {
        predictive(q).then(function (list) { if (my === seq) render(q, list, 0); }).catch(close);
      });
    }
    function items() { return $$('.x-row', panel); }
    function setActive(i) {
      var l = items(); l.forEach(function (el) { el.classList.remove('is-active'); });
      if (i >= 0 && i < l.length) { l[i].classList.add('is-active'); l[i].scrollIntoView({ block: 'nearest' }); }
      active = i;
    }

    input.setAttribute('autocomplete', 'off');
    input.addEventListener('focus', function () { loadIndex().catch(function () {}); if (input.value.trim().length >= 2) run(); });
    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 120); });
    input.addEventListener('keydown', function (e) {
      var l = items();
      if (e.key === 'ArrowDown') { e.preventDefault(); setActive(Math.min(active + 1, l.length - 1)); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(Math.max(active - 1, -1)); }
      else if (e.key === 'Escape') { close(); input.blur(); }
      else if (e.key === 'Enter' && active >= 0 && l[active]) { e.preventDefault(); W.location.href = l[active].href; }
    });
    D.addEventListener('click', function (e) { if (!host.contains(e.target)) close(); });
  }

  /* ---------- Find My Part ---------- */
  function initFinder() {
    var root = $('[data-x-finder]');
    if (!root) return;
    $$('[data-x-tab]', root).forEach(function (tab) {
      tab.addEventListener('click', function () {
        $$('[data-x-tab]', root).forEach(function (t) { t.classList.remove('is-on'); t.setAttribute('aria-selected', 'false'); });
        $$('[data-x-panel]', root).forEach(function (p) { p.hidden = true; });
        tab.classList.add('is-on'); tab.setAttribute('aria-selected', 'true');
        var panel = $('[data-x-panel="' + tab.dataset.xTab + '"]', root);
        panel.hidden = false;
        var inp = $('input', panel); if (inp) inp.focus();
      });
    });

    var mk = $('[data-x-make]', root), md = $('[data-x-model]', root), out = $('[data-x-results]', root);
    var INDEX = [], PAGE = 12;

    function fillMakes() {
      var counts = {};
      INDEX.forEach(function (p) { p.mk.forEach(function (m) { counts[m] = (counts[m] || 0) + 1; }); });
      var makes = Object.keys(counts).sort(function (a, b) {
        var ia = MAKE_ORDER.indexOf(a), ib = MAKE_ORDER.indexOf(b);
        if (ia < 0) ia = 99; if (ib < 0) ib = 99;
        return ia - ib || natural(a, b);
      });
      mk.innerHTML = '<option value="">Select make</option>' + makes.map(function (m) {
        return '<option value="' + esc(m) + '">' + esc(m) + ' (' + counts[m] + ')</option>';
      }).join('');
      mk.disabled = false;
    }
    function fillModels(make) {
      var counts = {};
      INDEX.forEach(function (p) { if (p.mk.indexOf(make) > -1) p.md.forEach(function (m) { counts[m] = (counts[m] || 0) + 1; }); });
      var models = Object.keys(counts).sort(natural);
      md.innerHTML = '<option value="">All ' + esc(make) + ' parts</option>' + models.map(function (m) {
        return '<option value="' + esc(m) + '">' + esc(m) + ' (' + counts[m] + ')</option>';
      }).join('');
      md.disabled = !models.length;
    }
    function show() {
      var make = mk.value, model = md.value;
      if (!make) { out.innerHTML = ''; store('xMachine', ''); return; }
      store('xMachine', JSON.stringify({ mk: make, md: model }));
      var forMake = INDEX.filter(function (p) { return p.mk.indexOf(make) > -1; });
      var exact = model ? forMake.filter(function (p) { return p.md.indexOf(model) > -1; }) : forMake.slice();
      var general = model ? forMake.filter(function (p) { return !p.md.length; }) : [];
      exact.sort(function (a, b) { return (b.a ? 1 : 0) - (a.a ? 1 : 0); });
      var label = make + (model ? ' ' + model : '');
      var shown = Math.min(PAGE, exact.length);
      var coll = MAKE_COLL[make];
      var html = '<div class="x-fr__head"><span>Your machine: <strong>' + esc(label) + '</strong></span>' +
        '<span class="x-fr__n">' + exact.length + ' part' + (exact.length === 1 ? '' : 's') + '</span></div>';
      html += '<div class="x-fr__list">' + (exact.length ? exact.slice(0, shown).map(function (p) { return rowHTML(p); }).join('')
        : '<p class="x-fr__none">Nothing listed for this exact model yet — call us, we can usually still get it.</p>');
      if (general.length) html += '<div class="x-fr__sub">Other ' + esc(make) + ' parts — check fit with us</div>' + general.slice(0, 6).map(function (p) { return rowHTML(p); }).join('');
      html += '</div>';
      if (exact.length > shown) html += '<button type="button" class="x-fr__more" data-x-more>Show more parts</button>';
      html += '<p class="x-fr__help">Can’t see it? <a href="tel:' + TEL + '">Call ' + TELTXT + '</a>' +
        (coll ? ' · <a href="' + ROOT + 'collections/' + coll + '">Browse all ' + esc(make) + ' parts →</a>' : '') + '</p>';
      out.innerHTML = html;
      var more = $('[data-x-more]', out);
      if (more) more.addEventListener('click', function () {
        var list = $('.x-fr__list', out), sub = $('.x-fr__sub', list);
        var frag = D.createElement('div');
        frag.innerHTML = exact.slice(shown, shown + PAGE).map(function (p) { return rowHTML(p); }).join('');
        while (frag.firstChild) list.insertBefore(frag.firstChild, sub);
        shown = Math.min(shown + PAGE, exact.length);
        if (shown >= exact.length) more.remove();
      });
    }

    mk.addEventListener('change', function () {
      if (mk.value) fillModels(mk.value); else { md.disabled = true; md.innerHTML = '<option value="">Select make first</option>'; }
      show();
    });
    md.addEventListener('change', show);

    loadIndex().then(function (idx) {
      INDEX = idx; fillMakes();
      var saved = null; try { saved = JSON.parse(store('xMachine') || 'null'); } catch (e) {}
      if (saved && saved.mk && [].some.call(mk.options, function (o) { return o.value === saved.mk; })) {
        mk.value = saved.mk; fillModels(saved.mk);
        if (saved.md && [].some.call(md.options, function (o) { return o.value === saved.md; })) md.value = saved.md;
        show();
      }
    }).catch(function () {
      mk.disabled = false;
      mk.innerHTML = '<option value="">Couldn’t load — call ' + TELTXT + '</option>';
    });
  }

  /* ---------- Cart drawer ---------- */
  var cartEl = null;
  function getCart() { return fetch(ROOT + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); }
  function setCount(n) {
    $$('[data-x-count]').forEach(function (el) { el.textContent = n; el.hidden = !n; });
  }
  function renderCart(cart) {
    setCount(cart.item_count);
    if (!cartEl) return;
    var body = $('[data-x-cart-body]', cartEl), foot = $('[data-x-cart-foot]', cartEl);
    if (!cart.item_count) {
      body.innerHTML = '<div class="x-cd__empty"><p>Your cart is empty.</p><a class="x-btn x-btn--pk" href="' + ROOT + '#find">Find my part</a></div>';
      foot.hidden = true; return;
    }
    body.innerHTML = cart.items.map(function (it, i) {
      var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<span class="x-ci__v">' + esc(it.variant_title) + '</span>' : '';
      return '<div class="x-ci">' +
        '<a class="x-ci__img" href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(sized(it.image, 160)) + '" alt="" width="72" height="72">' : '') + '</a>' +
        '<div class="x-ci__b"><a class="x-ci__t" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + variant +
        (it.sku ? '<span class="x-ci__s">Part no. ' + esc(it.sku) + '</span>' : '') +
        '<div class="x-ci__row"><div class="x-qty x-qty--sm">' +
        '<button type="button" data-x-line="' + (i + 1) + '" data-x-set="' + (it.quantity - 1) + '" aria-label="Decrease">−</button>' +
        '<span>' + it.quantity + '</span>' +
        '<button type="button" data-x-line="' + (i + 1) + '" data-x-set="' + (it.quantity + 1) + '" aria-label="Increase">+</button></div>' +
        '<b>' + money(it.final_line_price) + '</b></div>' +
        '<button type="button" class="x-ci__rm" data-x-line="' + (i + 1) + '" data-x-set="0">Remove</button></div></div>';
    }).join('');
    $('[data-x-sub]', cartEl).textContent = money(cart.items_subtotal_price);
    foot.hidden = false;
  }
  function openCart() {
    if (!cartEl) { W.location.href = ROOT + 'cart'; return; }
    cartEl.hidden = false;
    requestAnimationFrame(function () { cartEl.classList.add('is-open'); });
    D.body.classList.add('x-lock');
    var c = $('[data-x-cart-close]', cartEl); if (c) c.focus();
  }
  function closeCart() {
    if (!cartEl) return;
    cartEl.classList.remove('is-open');
    D.body.classList.remove('x-lock');
    setTimeout(function () { cartEl.hidden = true; }, 250);
  }
  function changeLine(line, qty) {
    return fetch(ROOT + 'cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: Math.max(0, qty) })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }
  function initCart() {
    cartEl = $('[data-x-cart]');
    if (cartEl) {
      cartEl.addEventListener('click', function (e) {
        var b = e.target.closest('[data-x-set]');
        if (b) { b.disabled = true; changeLine(Number(b.dataset.xLine), Number(b.dataset.xSet)); return; }
        if (e.target.closest('[data-x-cart-close]') || e.target === cartEl) closeCart();
      });
    }
    $$('[data-x-cart-open]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        if (!cartEl || D.body.classList.contains('t-cart')) return;
        e.preventDefault(); getCart().then(renderCart); openCart();
      });
    });
    var lastBtn = null;
    D.addEventListener('click', function (e) { var b = e.target.closest('form[data-x-add] button[type=submit]'); if (b) lastBtn = b; }, true);
    D.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f.matches || !f.matches('form[data-x-add]')) return;
      e.preventDefault();
      var btn = e.submitter || lastBtn || $('button[type=submit]', f);
      var buy = btn && btn.hasAttribute('data-x-buy');
      var msg = $('[data-x-msg]', f);
      var label = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.innerHTML = buy ? 'One moment…' : 'Adding…'; }
      if (msg) msg.textContent = '';
      fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(f) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () {
          if (buy) { W.location.href = ROOT + 'checkout'; return; }
          return getCart().then(function (c) { renderCart(c); openCart(); });
        })
        .catch(function (err) {
          if (msg) msg.textContent = (err && (err.description || err.message)) || ('Couldn’t add that — call ' + TELTXT);
        })
        .then(function () { if (btn && !buy) { btn.disabled = false; btn.innerHTML = label; } });
    });
  }

  /* ---------- Header: drawer menu, sticky state, announcement ---------- */
  function initHeader() {
    var nav = $('[data-x-nav]');
    function openNav() { if (!nav) return; nav.hidden = false; requestAnimationFrame(function () { nav.classList.add('is-open'); }); D.body.classList.add('x-lock'); }
    function closeNav() { if (!nav) return; nav.classList.remove('is-open'); D.body.classList.remove('x-lock'); setTimeout(function () { nav.hidden = true; }, 250); }
    $$('[data-x-nav-open]').forEach(function (b) { b.addEventListener('click', openNav); });
    if (nav) nav.addEventListener('click', function (e) { if (e.target === nav || e.target.closest('[data-x-nav-close]') || e.target.closest('a[href*="#"]')) closeNav(); });
    D.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeNav(); closeCart(); D.body.classList.remove('x-filt-open'); } });

    var head = $('.xh-bar');
    if (head) {
      var on = false;
      W.addEventListener('scroll', function () { var s = W.scrollY > 40; if (s !== on) { on = s; head.classList.toggle('is-stuck', s); } }, { passive: true });
    }
    var rot = $$('[data-x-rot] > *');
    if (rot.length > 1) {
      var i = 0;
      setInterval(function () { rot[i].classList.remove('is-on'); i = (i + 1) % rot.length; rot[i].classList.add('is-on'); }, 4500);
    }
  }

  /* ---------- Product page ---------- */
  function initProduct() {
    $$('.x-qty input').forEach(function (inp) {
      var wrap = inp.closest('.x-qty');
      $$('[data-x-step]', wrap).forEach(function (b) {
        b.addEventListener('click', function () {
          var v = Math.max(1, (parseInt(inp.value, 10) || 1) + Number(b.dataset.xStep));
          inp.value = v;
        });
      });
    });
    var track = $('[data-x-gal]');
    if (track) {
      var thumbs = $$('[data-x-th]'), count = $('[data-x-gal-n]');
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { track.scrollTo({ left: Number(t.dataset.xTh) * track.clientWidth, behavior: 'smooth' }); });
      });
      var tm;
      track.addEventListener('scroll', function () {
        clearTimeout(tm);
        tm = setTimeout(function () {
          var i = Math.round(track.scrollLeft / track.clientWidth);
          thumbs.forEach(function (t, j) { t.classList.toggle('is-on', j === i); });
          if (count) count.textContent = (i + 1) + ' / ' + track.children.length;
        }, 60);
      }, { passive: true });
    }
    var sel = $('[data-x-variant]');
    if (sel) {
      sel.addEventListener('change', function () {
        var o = sel.options[sel.selectedIndex];
        var pr = $('[data-x-price]'), inc = $('[data-x-inc]'), st = $('[data-x-stock]');
        if (pr) pr.textContent = o.dataset.price;
        if (inc) inc.textContent = o.dataset.inc;
        if (st) { st.textContent = o.dataset.stock; st.className = 'x-stock x-stock--' + o.dataset.st; }
        $$('[data-x-sku]').forEach(function (s) { s.textContent = o.dataset.sku || '—'; });
        $$('form[data-x-add] button[type=submit]').forEach(function (b) { b.disabled = o.dataset.avail !== '1'; });
        try { history.replaceState(null, '', '?variant=' + o.value); } catch (e) {}
      });
    }
  }

  /* ---------- Collection filters ---------- */
  function initFilters() {
    var form = $('#xFilt');
    if (!form) return;
    function go() {
      var fd = new FormData(form), p = new URLSearchParams();
      fd.forEach(function (v, k) { if (v !== '') p.append(k, v); });
      $$('select[form="xFilt"]').forEach(function (s) { if (s.value) p.set(s.name, s.value); });
      W.location.search = p.toString();
    }
    form.addEventListener('change', go);
    form.addEventListener('submit', function (e) { e.preventDefault(); go(); });
    $$('select[form="xFilt"]').forEach(function (s) { s.addEventListener('change', go); });
    $$('[data-x-filt-open]').forEach(function (b) { b.addEventListener('click', function () { D.body.classList.add('x-filt-open'); }); });
    $$('[data-x-filt-close]').forEach(function (b) { b.addEventListener('click', function () { D.body.classList.remove('x-filt-open'); }); });
  }

  /* ---------- Zero-result search: try the part-number index ---------- */
  function initZero() {
    var z = $('[data-x-zero]');
    if (!z) return;
    var q = z.dataset.xZero, out = $('[data-x-zero-res]', z);
    loadIndex().then(function (idx) {
      var list = match(idx, q, 12);
      if (!list.length) return;
      out.innerHTML = '<h2 class="x-h3" style="margin-bottom:12px">Close matches for “' + esc(q) + '”</h2><div class="x-fr__list">' +
        list.map(function (p) { return rowHTML(p, q); }).join('') + '</div>';
      out.hidden = false;
    }).catch(function () {});
  }

  /* ---------- Request-a-part prefill ---------- */
  function initRequest() {
    D.addEventListener('click', function (e) {
      var a = e.target.closest('a[data-q]');
      if (!a) return;
      store('xReqPart', a.dataset.q);
    });
    var f = $('[data-x-req-part]');
    if (f && !f.value) { var v = store('xReqPart'); if (v) f.value = v; }
  }

  function init() {
    initHeader();
    $$('[data-x-search]').forEach(attachSearch);
    initFinder();
    initCart();
    initProduct();
    initFilters();
    initZero();
    initRequest();
  }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', init); else init();
})();
